import React, { Component } from 'react';
import { Row, Col, Table, Pagination } from "react-bootstrap";
import { toast } from 'react-toastify';
import DatePicker from 'react-date-picker';
import Switch from "react-switch";

import Select from 'react-select';

import { CustomCard } from "../../../components/Card/CustomCard";

import { ConsultCarreras} from '../../../funciones/ModalidadesFunction';
import { ConsultaSemestres} from '../../../funciones/CalifDirFunction';
import { ConsultaProfesSem } from "../../../funciones/CalifDirFunction";

import { CantTransaccionesDia, TransaccionesDia, CantTransaccionesMes, TransaccionesMes, CantTransaccionesRango,
    TransaccionesRango, CantTransaccionesSeccion, TransaccionesSeccion, CantTransaccionesEst, TransaccionesEst } from "../../../funciones/IngresosFunction";

import ModalReports from '../../../components/Reportes/ModalReports';
import IngresosRpt from '../../../components/Reportes/IngresosRpt';

let maxPaginas = 10;
let fecha = new Date();
let fecha2 = new Date();
let statusbtn = false;
let statusContentSecc = false;
let statusContentSecc2 = false;

let statusContentEst = false;

class GeneralIngresos extends Component {
    state = {
        cantRegistros: { value: 10, label: '- Mostrar 10 Registros -' },
        tipoIngreso: { value: '', label: '- Selecciona un Tipo -' },
        pagSelect: { value: 1, label: '- 1 -' },
        mesSelect: { value: "", label: '- Mes -' },
        valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
        carreras: [],
        valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
        semestres: [],
        valorSeccion: { value: '', label: '- Selecciona una Sección -' },
        secciones: [],
        ingresos: 0,
        transacciones: [],
        pag: 1,
        paginas: 0,
        cantTransacciones: 0,
        preloader: <React.Fragment>Selecciona un mes</React.Fragment>,
        preloaderIcon: "",
        fecha: fecha,
        fecha2: fecha2,
        boton1: {
            icon: "fa fa-search",
            text: "Buscar"
        },
        string: "",
        preloaderEst: "Ingresa una Cédula, nombre o apellido del estudiante",
        openWR: false,
        yearSel: fecha.getFullYear(),
        histEst: false
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: event.target.value 
        });
    };

    updTransaciones = (tipo) => {
        statusbtn = false;
        switch (tipo) {
            case "Ingresos del Dia":
                CantTransaccionesDia ((resp) => {
                    let pags = (resp[0]) / (this.state.cantRegistros.value);
                    let pagis = 0;
                    pagis = parseInt(pags)
                    if (!pags % 1 == 0) pagis ++;
                    this.setState({
                        mesSelect: { value: "01", label: '- Enero -' },
                        ingresos: resp[1],
                        paginas: pagis
                    })
                })

                TransaccionesDia (this.state.pag, this.state.cantRegistros.value, (resp) => {
                    let text = "";
                    if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                    this.setState({
                        preloader: text,
                        transacciones: resp
                    })
                })
            break;
            case "Ingresos del Mes":
                /* CantTransaccionesMes (this.state.mesSelect.value, this.state.yearSel, this.state.histEst, (resp) => {
                    let pags = (resp[0]) / (this.state.cantRegistros.value);
                    let pagis = 0;
                    pagis = parseInt(pags)
                    if (!pags % 1 == 0) pagis ++;
                    this.setState({
                        ingresos: resp[1],
                        paginas: pagis
                    })
                })

                TransaccionesMes (this.state.mesSelect.value, this.state.pag, this.state.cantRegistros.value, this.state.yearSel, this.state.histEst, (resp) => {
                    let text = "";
                    if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                    this.setState({
                        preloader: text,
                        transacciones: resp
                    })
                }) */
            break;
            case "Ingresos por Rango de Fechas":
                /* En el botón Buscar */
                return null;
            case "Ingresos por Sección":
                ConsultCarreras ((resp) => {
                    this.setState({carreras: resp})
                })
                /* Al selecionar la Seccion */
            break;
            case "Ingresos por Estudiante":
                /* Al buscar un string */
            default:
        }
    }

    valorTipo = (tipoIngreso) => {
        statusContentSecc = false;
        statusContentSecc2 = false;
        statusContentEst = false;
        this.updTransaciones(tipoIngreso.label)
        this.setState({
            valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
            tipoIngreso,
            string: "",
            preloaderEst: "",
            paginas: 0,
        });
    }

    valorSelectCarrera = (valorCarrera) => {
        this.setState({
            valorCarrera,
            valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
            valorSeccion: { value: '', label: '- Selecciona una Sección -' },
            secciones: [],
            semestres: [{value: '', label: '- Espera -'}]
        }, () => {
            ConsultaSemestres(valorCarrera.value, (resp) => {
                this.setState({
                    semestres: resp[0],
                })
            })
        });
    }

    valorSelectSemestre = (valorSemestre) => {
        statusContentSecc2 = true;
        this.setState({
            valorSemestre,
            valorSeccion: { value: '', label: '- Selecciona una Sección -' },
            secciones: [{value: '', label: '- Espera -'}]
        }, () => {
            ConsultaProfesSem (valorSemestre.value, (resp) => {
                if(resp[0].length > 0) {
                    let Contenido = [];
                     for(let i in resp[0]){
                         Contenido.push({
                             value: resp[0][i].id, label: `${resp[0][i].carrera_name} [${resp[0][i].materia_name} - ${resp[0][i].nombre}]`
                         })
                     }
 
                     this.setState({ secciones: Contenido })
                 }
            })
        });
    }

    cambiaPagSelect = (pagSelect) => {
        this.setState({
            pagSelect
        }, () => {
            TransaccionesDia (this.state.pagSelect.value, this.state.cantRegistros.value, (resp) => {
                let text = "";
                if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                this.setState({
                    preloader: text,
                    transacciones: resp,
                    preloaderIcon: ""
                })
            })
        });
    }

    cambiaRegistros = (cantRegistros) => {
        this.updTransaciones(this.state.tipoIngreso.label)
        this.setState({
            cantRegistros,
            pagSelect: { value: 1, label: '- 1 -' },
            pag: 1,
            transacciones: [],
            preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando transacciones</React.Fragment>
        }, () => {
            switch (this.state.tipoIngreso.label) {
                case "Ingresos del Dia":
                    TransaccionesDia (this.state.pag, this.state.cantRegistros.value, (resp) => {
                        let text = "";
                        if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                        this.setState({
                            preloader: text,
                            transacciones: resp,
                            preloaderIcon: ""
                        })
                    })
                break;
                case "Ingresos del Mes":
                    TransaccionesMes (this.state.mesSelect.value, this.state.pag, this.state.cantRegistros.value, this.state.yearSel, this.state.histEst, (resp) => {
                        let text = "";
                        if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                        this.setState({
                            preloader: text,
                            transacciones: resp,
                            preloaderIcon: ""
                        })
                    })
                break;
                case "Ingresos por Rango de Fechas":
                    TransaccionesRango (this.state.fecha, this.state.fecha2, this.state.pag, this.state.cantRegistros.value, (resp) => {
                        let text = "";
                        if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                        this.setState({
                            preloader: text,
                            transacciones: resp,
                            preloaderIcon: ""
                        })
                    })
                break;
                case "Ingresos por Sección":
                    TransaccionesSeccion (this.state.valorSeccion.value, this.state.pag, this.state.cantRegistros.value, (resp) => {
                        let text = "";
                        if (resp === undefined){
                            text = "La búsqueda no obtuvo resultados"
                        }else{
                            if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                        }
                        this.setState({
                            preloader: text,
                            transacciones: resp,
                            preloaderIcon: ""
                        })
                    })
                break;
                case "Ingresos por Estudiante":
                    TransaccionesEst (this.state.string, this.state.pag, this.state.cantRegistros.value, (resp) => {
                        let text = "";
                        statusContentEst = true;
                        if (resp === undefined){
                            text = "La búsqueda no obtuvo resultados"
                        }else{
                            if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                        }
                        
                        this.setState({
                            preloader: text,
                            transacciones: resp,
                            preloaderIcon: ""
                        })
                    })
                default: return null
            }
        });
    }

    cambiaPag = (pag) => (e) => {
        if (this.state.transacciones === undefined) return null;
        if (this.state.transacciones.length === 0) return null;

        switch (this.state.tipoIngreso.label) {
            case "Ingresos del Dia":
                this.setState({
                    pag: pag,
                    preloaderIcon: <i className="fa fa-spinner fa-spin"></i>
                }, () => {
                    TransaccionesDia (this.state.pag, this.state.cantRegistros.value, (resp) => {
                        let text = "";
                        if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                        this.setState({
                            preloader: text,
                            transacciones: resp,
                            preloaderIcon: ""
                        })
                    })
                })
            break;
            case "Ingresos del Mes":
                this.setState({
                    pag: pag,
                    preloaderIcon: <i className="fa fa-spinner fa-spin"></i>
                }, () => {
                    TransaccionesMes (this.state.mesSelect.value, this.state.pag, this.state.cantRegistros.value, this.state.yearSel, this.state.histEst, (resp) => {
                        let text = "";
                        if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                        this.setState({
                            preloader: text,
                            transacciones: resp,
                            preloaderIcon: ""
                        })
                    })
                })
            break;
            case "Ingresos por Rango de Fechas":
                this.setState({
                    pag: pag,
                    preloaderIcon: <i className="fa fa-spinner fa-spin"></i>
                }, () => {
                    TransaccionesRango (this.state.fecha, this.state.fecha2, this.state.pag, this.state.cantRegistros.value, (resp) => {
                        let text = "";
                        if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                        this.setState({
                            preloader: text,
                            transacciones: resp,
                            preloaderIcon: ""
                        })
                    })
                })
            break;
            case "Ingresos por Sección":
                this.setState({
                    pag: pag,
                    preloaderIcon: <i className="fa fa-spinner fa-spin"></i>
                }, () => {
                    TransaccionesSeccion (this.state.valorSeccion.value, this.state.pag, this.state.cantRegistros.value, (resp) => {
                        let text = "";
                        if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                        this.setState({
                            preloader: text,
                            transacciones: resp,
                            preloaderIcon: ""
                        })
                    })
                })
            case "Ingresos por Estudiante":
                this.setState({
                    pag: pag,
                    preloaderIcon: <i className="fa fa-spinner fa-spin"></i>
                }, () => {
                    TransaccionesEst (this.state.string, this.state.pag, this.state.cantRegistros.value, (resp) => {
                        let text = "";
                        statusContentEst = true;
                        if (resp === undefined){
                            text = "La búsqueda no obtuvo resultados"
                        }else{
                            if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                        }
                        
                        this.setState({
                            preloader: text,
                            transacciones: resp,
                            preloaderIcon: ""
                        })
                    })
                })
            default: return null
        }
    }

    cambiaMes = (mesSelect) => {
        if (mesSelect.value === "") {
            this.setState({
                mesSelect,
                pag: 1,
                transacciones: [],
                preloader: <React.Fragment>Selecciona un mes</React.Fragment>
            });
            return null
        }

        this.setState({
            mesSelect,
            pag: 1,
            transacciones: [],
            preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando transacciones</React.Fragment>,
            ingresos: <i className = "fa fa-spinner fa-spin"></i>
        }, () => {
            CantTransaccionesMes (mesSelect.value, this.state.yearSel, this.state.histEst, (resp) => {
                let pags = (resp[0]) / (this.state.cantRegistros.value);
                let pagis = 0;
                pagis = parseInt(pags)
                if (!pags % 1 == 0) pagis ++;
                this.setState({
                    ingresos: resp[1],
                    paginas: pagis
                })
            })

            TransaccionesMes (this.state.mesSelect.value, this.state.pag, this.state.cantRegistros.value, this.state.yearSel, this.state.histEst, (resp) => {
                let text = "";
                if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                this.setState({
                    preloader: text,
                    transacciones: resp
                })
            })
        })
    }

    cambiaFecha = (date) => { this.setState({ fecha: date }) }
    cambiaFecha2 = (date) => { this.setState({ fecha2: date }) }

    valorSelectSeccion = (valorSeccion) => {
        statusContentSecc = true;
        this.setState({
            valorSeccion,
            pag: 1,
            transacciones: [],
            preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando transacciones</React.Fragment>
        }, () => {
            CantTransaccionesSeccion (valorSeccion.value, (resp) => {
                let pags = (resp[0]) / (this.state.cantRegistros.value);
                let pagis = 0;
                pagis = parseInt(pags)
                if (!pags % 1 == 0) pagis ++;
                this.setState({
                    ingresos: resp[1],
                    paginas: pagis
                })
            })

            TransaccionesSeccion (this.state.valorSeccion.value, this.state.pag, this.state.cantRegistros.value, (resp) => {
                let text = "";
                if (resp === undefined){
                    text = "La búsqueda no obtuvo resultados"
                }else{
                    if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                }
                
                this.setState({
                    preloader: text,
                    transacciones: resp
                })
            })
        })
    }

    contenido = () => {
        let { tipoIngreso, ingresos, cantRegistros, transacciones, pag, preloader, paginas, pagSelect,
            preloaderIcon, mesSelect, fecha, fecha2, boton1, valorCarrera, carreras, valorSemestre,
            semestres, valorSeccion, secciones, string, preloaderEst, yearSel, histEst } = this.state;

        const Registros = [
            { value: 10, label: '- Mostrar 10 Registros -' },
            { value: 15, label: '- Mostrar 15 Registros -' },
            { value: 20, label: '- Mostrar 20 Registros -' },
            { value: 30, label: '- Mostrar 30 Registros -' },
            { value: 50, label: '- Mostrar 50 Registros -' },
            { value: "all", label: '- Todos los Registros -' },
        ];

        const meses = [
            { value: "", label: '- Mes -' },
            { value: "01", label: '- Enero -' },
            { value: "02", label: '- Febrero -' },
            { value: "03", label: '- Marzo -' },
            { value: "04", label: '- Abril -' },
            { value: "05", label: '- Mayo -' },
            { value: "06", label: '- Junio -' },
            { value: "07", label: '- Julio -' },
            { value: "08", label: '- Agosto -' },
            { value: "09", label: '- Septiembre -' },
            { value: "10", label: '- Octubre -' },
            { value: "11", label: '- Noviembre -' },
            { value: "12", label: '- Diciembre -' },
        ];

        const styles = {
            padding: 5, fontSize: 12
        }

        const styles2 = {
            padding: 5, fontSize: 10
        }

        const customStyles = {
            menu: (provided) => ({
              ...provided,
              zIndex: 10,
            })
        }

        let detallesIngreso = () => {
            if (transacciones === undefined){
                return (
                    <tr>
                        <td align="center" colSpan={5}>{preloader}</td>
                    </tr>
                )
            }else{
                if (transacciones.length === 0) return (
                    <tr>
                        <td align="center" colSpan={5}>{preloader}</td>
                    </tr>
                )
            }
            

            let nombre = (string) => {
                let nom = ""
                if(string !== null) nom = string;
                return nom;
            }

            return (transacciones.map(option => (
                <tr key={option.id}>
                    <td style={styles}><strong>{option.id}</strong></td>
                    <td style={styles2}>
                        <div className = "text-danger"><strong>{`${option.nacionalidad}${option.ci}`}</strong></div>
                        {option.nombre_1} {nombre(option.nombre_2)} {option.apellido_1} {nombre(option.apellido_2)}
                    </td>
                    <td style={styles}>{option.fecha}</td>
                    <td style={styles2}>{option.item}</td>
                    <td style={styles} align="right"><strong className="text-danger">{parseFloat(option.haber).toFixed(2)} Bs.</strong></td>
                </tr>
            )))
        }

        let items = () => {
            let items = [];
            for (let i = 1; i <= paginas; i++) {
                items.push(
                  <Pagination.Item key={i} active={i === pag} onClick={this.cambiaPag(i)}>
                    {i}
                  </Pagination.Item>,
                );
            }
            return items;
        }

        let itemsPag = () => {
            /* if (transacciones.length === 0) return null; */

            if (paginas > maxPaginas){
                let contenido = []
                for (let i = 1; i <= paginas; i++) {
                    contenido.push({
                        value: i, label: `- ${i} -`
                    })
                }

                let funcPaginacion = (operacion) => {
                    this.setState({
                        pagSelect: operacion ,
                        preloaderIcon: <i className="fa fa-spinner fa-spin"></i>
                    }, () => {
                        TransaccionesDia (this.state.pagSelect.value, this.state.cantRegistros.value, (resp) => {
                            let text = "";
                            if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                            this.setState({
                                preloader: text,
                                transacciones: resp,
                                preloaderIcon: ""
                            })
                        })
                    })
                }

                return(
                    <Row className="custom-mt-10" style={{paddingBottom:15, paddingTop: 5}}>
                        <Col md={4}></Col>
                        <Col md={1} align="center">
                            <button className="btn btn-primary" onClick={() => {
                                if (pagSelect.value === 1) return null;
                                funcPaginacion({ value: (pagSelect.value) - 1, label: `- ${(pagSelect.value) - 1} -` })
                            }} style={{borderWidth: 1}}><i className="fa fa-chevron-left"></i></button>
                        </Col>
                        <Col md={2}>
                            <Select
                                styles={customStyles}
                                isSearchable ={true}
                                value={pagSelect}
                                onChange={this.cambiaPagSelect}
                                options={contenido}
                            />
                        </Col>
                        <Col md={1} align="center">
                            <button className="btn btn-primary" onClick={() => {
                                if (pagSelect.value > paginas) return null;
                                funcPaginacion({ value: (pagSelect.value) + 1, label: `- ${(pagSelect.value) + 1} -` })
                            }} style={{borderWidth: 1}}><i className="fa fa-chevron-right"></i></button>
                        </Col>
                        <Col md={4}></Col>
                    </Row>
                )
            }

            return (
                <div align="center">
                    <Pagination bsSize="sm">{items()}</Pagination>
                </div>
            )
        }

        let selectRegistros = () => (
            <div className="custom-alert-info">
                <Row>
                    <Col md={8} style={{marginTop: 10, paddingLeft: 20}}>
                        Detalles de las transacciones
                    </Col>
                    <Col md={4}>
                        <Select
                            styles={customStyles}
                            isSearchable ={true}
                            value={cantRegistros}
                            onChange={this.cambiaRegistros}
                            options={Registros}
                        />
                    </Col>
                </Row>
            </div>
        )

        let detallesRegistro = () => (
            <React.Fragment>
                <Col md={12}>
                    {itemsPag()}
                </Col>
                <Col md={12}>
                    <div align="right" style={{marginTop: -14, paddingBottom: 4}}>{preloaderIcon}</div>
                    <div className="table-responsive" style={{backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                        <Table striped hover style={{marginBottom: 0}}>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="100px" style={styles}><strong>N°</strong></td>
                                    <td width="40%" style={styles}><strong>Estudiante</strong></td>
                                    <td width="15%" style={styles}><strong>Fecha</strong></td>
                                    <td width="30%" style={styles}><strong>Descripción</strong></td>
                                    <td width="15%" style={styles} align="right"><strong>Monto</strong></td>
                                </tr>
                                {detallesIngreso()}
                            </tbody>
                        </Table>
                    </div>
                    <div align="right" style={{marginTop: 4, marginBottom: -14}}>{preloaderIcon}</div>
                </Col>
                <Col md={12}>
                    {itemsPag()}
                </Col>
            </React.Fragment>
        )

        let detalleRango = () => {
            if (statusbtn === false) return null;

            return (
                <React.Fragment>
                    <div className="custom-alert-danger custom-mt-10">
                        <Row>
                            <Col md={4}>
                                <Select
                                    styles={customStyles}
                                    isSearchable ={true}
                                    value={cantRegistros}
                                    onChange={this.cambiaRegistros}
                                    options={Registros}
                                />
                            </Col>
                            <Col md={5}>
                                Total de ingresos del rango:
                                <div><strong>{ingresos} Bs.</strong></div>
                            </Col>
                            <Col md={3} align="right">
                                <button onClick={()=> {this.setState({openWR: true})}} title="Imprimir el listado de las transacciones" className="btn btn-relleno-danger" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        {detallesRegistro()}
                    </Row>
                </React.Fragment>
            )
        }

        let totalSeccion = () => {
            if (statusContentSecc === false) return null;
            return (
                <React.Fragment>
                    Total de ingresos del rango:
                    <div><strong>{ingresos} Bs.</strong></div>
                </React.Fragment>
            )
        }

        let detReg = () => {
            if (statusContentEst === false) return null;
            return (
                <React.Fragment>
                    {regEst()}
                    <Row>
                        {detallesRegistro()}
                    </Row>
                </React.Fragment>
            )
        }

        let detRegSecc = () => {
            if (statusContentSecc === false) return null;
            return (
                <React.Fragment>
                    <Row>
                        {detallesRegistro()}
                    </Row>
                </React.Fragment>
            )
        }

        let seccionesLr = () => {
            if (statusContentSecc2 === false) return null;

            let print = () => {
                if (valorSeccion.value === "") {
                    toast.error("Debes seleccionar primero la sección",{autoClose: 4000});
                    return null;
                }

                this.setState({openWR: true})
            }

            return(
                <React.Fragment>
                    <div className="custom-alert-danger custom-mt-10">
                        <Row>
                            <Col md={6}>
                                <Select
                                    styles={customStyles}
                                    isSearchable ={true}
                                    value={valorSeccion}
                                    onChange={this.valorSelectSeccion}
                                    options={secciones}
                                />
                            </Col>
                            <Col md={3}>
                                <Select
                                    styles={customStyles}
                                    isSearchable ={true}
                                    value={cantRegistros}
                                    onChange={this.cambiaRegistros}
                                    options={Registros}
                                />
                            </Col>
                            <Col md={3} align="right">
                                <button onClick={() => {print()}} title="Imprimir el listado de las transacciones" className="btn btn-relleno-danger" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                            </Col>
                        </Row>
                    </div>
                </React.Fragment>
            )
        }

        let regEst = () => (
            <div className="custom-alert-danger custom-mt-10">
                <Row>
                    <Col md={6}>
                        <Select
                            styles={customStyles}
                            isSearchable ={true}
                            value={cantRegistros}
                            onChange={this.cambiaRegistros}
                            options={Registros}
                        />
                    </Col>
                    <Col md={6} align="right">
                        <button onClick={()=> {this.setState({openWR: true})}} title="Imprimir el listado de las transacciones" className="btn btn-relleno-danger" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                    </Col>
                </Row>
            </div>
        )

        let detallesEst = () => {
            if (this.state.transacciones === undefined) return null;
            if (this.state.transacciones.length === 0) return (
                <div className="text-danger" align="center">{preloaderEst}</div>
            );
        }
        
        let enterTab = () => (e) => {
            if (e.which === 13){
                if (this.state.string === "") return null;

                this.setState ({
                    transacciones: [],
                    preloaderEst: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando, espera</React.Fragment>
                }, () => {
                    CantTransaccionesEst(string, (resp) => {
                        let pags = (resp[0]) / (this.state.cantRegistros.value);
                        let pagis = 0;
                        pagis = parseInt(pags)
                        if (!pags % 1 == 0) pagis ++;
                        this.setState({
                            ingresos: resp[1],
                            paginas: pagis
                        })
                    })

                    TransaccionesEst (string, pag, cantRegistros.value, (resp) => {
                        let text = "";
                        statusContentEst = true;
                        if (resp === undefined){
                            text = "La búsqueda no obtuvo resultados"
                        }else{
                            if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                        }
                        
                        this.setState({
                            preloader: text,
                            transacciones: resp
                        })
                    })
                })
            }
        }

        let contentType = () => {
            switch (tipoIngreso.label) {
                case "Ingresos del Dia":
                    return (
                        <Row>
                            <Col md={12}>
                                <div className="custom-alert-danger">
                                    <Row>
                                        <Col md={8} style={{marginTop: 10, paddingLeft: 20}}>
                                            Total de ingresos del dia: <strong>{ingresos} Bs.</strong>
                                        </Col>
                                        <Col md={4} align="right">
                                            <button onClick={()=> {this.setState({openWR: true})}} title="Imprimir el listado de las transacciones" className="btn btn-relleno-danger" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={12} className="custom-mt-10">
                                {selectRegistros()}
                            </Col>
                            {detallesRegistro()}
                        </Row>
                    )
                case "Ingresos del Mes":
                    return (
                        <Row>
                            <Col md={12}>
                                <div className="custom-alert-danger">
                                    <Row>
                                        <Col md={9}>
                                            <Col md={4} align = "center" title = "Consultar asientos del archivo histórico">
                                                <div style = {{fontSize: 11}}>Archivo Histórico</div>
                                                <Switch height={18} width={36} onChange={() => {this.setState({
                                                    histEst: !histEst,
                                                    mesSelect: { value: "", label: '- Mes -' },
                                                    pag: 1,
                                                    transacciones: [],
                                                    preloader: <React.Fragment>Selecciona un mes</React.Fragment>,
                                                    ingresos: 0,
                                                })}} checked={histEst} />
                                            </Col>
                                            <Col md={3}>
                                                <input type = "number" placeholder = "Año" title =  "Selecciona el año de la consulta" className = "form-control" value = {yearSel} onChange = {(e)=> {this.setState({yearSel: e.target.value})}}/>
                                            </Col>
                                            <Col md={5}>
                                                <Select
                                                    styles={customStyles}
                                                    isSearchable ={true}
                                                    value={mesSelect}
                                                    onChange={this.cambiaMes}
                                                    options={meses}
                                                />
                                            </Col>
                                            <Col md={12} style={{marginTop: 10, paddingLeft: 20}}>
                                                Total de ingresos del mes de {(mesSelect.label).replace(/-/g, '')}: <strong>{ingresos} Bs.</strong>
                                            </Col>
                                        </Col>
                                        <Col md={3} align="right" style = {{marginTop: 15}}>
                                            <button onClick={()=> {this.setState({openWR: true})}} title="Imprimir el listado de las transacciones" className="btn btn-relleno-danger" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={12} className="custom-mt-10">
                                {selectRegistros()}
                            </Col>
                            {detallesRegistro()}
                        </Row>
                    )
                case "Ingresos por Rango de Fechas":
                    return (
                        <Row>
                            <Col md={12}>
                                <div className="custom-alert-info">
                                    <Row>
                                        <Col md={4}>
                                            <DatePicker
                                                clearIcon= ""
                                                calendarIcon= {<i className="fa fa-calendar"></i>}
                                                className="form-control"
                                                onChange={this.cambiaFecha}
                                                value={fecha}
                                            />
                                            <div style={{fontSize: 12}}>Desde</div>
                                        </Col>
                                        <Col md={4}>
                                            <DatePicker
                                                clearIcon= ""
                                                calendarIcon= {<i className="fa fa-calendar"></i>}
                                                className="form-control"
                                                onChange={this.cambiaFecha2}
                                                value={fecha2}
                                            />
                                            <div style={{fontSize: 12}}>Hasta</div>
                                        </Col>
                                        <Col md={4} align="right" style={{paddingTop: 10}}>
                                            <button className="btn btn-primary" onClick={()=> {
                                                this.setState({
                                                    boton1:{
                                                        icon: "fa fa-spinner fa-spin",
                                                        text: "Espera"
                                                    }
                                                }, () => {
                                                    CantTransaccionesRango (fecha, fecha2, (resp) => {
                                                        let pags = (resp[0]) / (this.state.cantRegistros.value);
                                                        let pagis = 0;
                                                        pagis = parseInt(pags)
                                                        if (!pags % 1 == 0) pagis ++;
                                                        this.setState({
                                                            ingresos: resp[1],
                                                            paginas: pagis
                                                        })
                                                    })

                                                    TransaccionesRango (fecha, fecha2, pag, cantRegistros.value, (resp) => {
                                                        let text = "";
                                                        statusbtn = true;
                                                        if (resp.length === 0) text = "La búsqueda no obtuvo resultados"
                                                        this.setState({
                                                            preloader: text,
                                                            transacciones: resp,
                                                            boton1:{
                                                                icon: "fa fa-search",
                                                                text: "Buscar"
                                                            }
                                                        })
                                                    })
                                                })
                                            }} style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                                        </Col>
                                    </Row>
                                </div>
                                {detalleRango()}
                            </Col>
                        </Row>
                    )
                case "Ingresos por Sección":
                    return(
                        <React.Fragment>
                            <div className="custom-alert-info">
                                <Row>
                                    <Col md={4}>
                                        <Select
                                            styles={customStyles}
                                            isSearchable ={true}
                                            value={valorCarrera}
                                            onChange={this.valorSelectCarrera}
                                            options={carreras}
                                        />
                                        <span className="text-muted" style={{fontSize: 10}}>Selecciona una Carrera</span>
                                    </Col>
                                    <Col md={4}>
                                        <Select
                                            styles={customStyles}
                                            isSearchable ={true}
                                            value={valorSemestre}
                                            onChange={this.valorSelectSemestre}
                                            options={semestres}
                                        />
                                        <span className="text-muted" style={{fontSize: 10}}>Semestres</span>
                                    </Col>
                                    <Col md={4} align="right">
                                        {totalSeccion()}
                                    </Col>
                                </Row>
                            </div>
                            {seccionesLr()}
                            {detRegSecc()}
                        </React.Fragment>
                    )
                case "Ingresos por Estudiante":
                    return (
                        <React.Fragment>
                            <div className="custom-alert-info" style={{padding: 5}}>
                                <Row>
                                    <Col md={6}>
                                        <input type="text" value ={string} onChange={this.cambiaValor("string")} onKeyPress={enterTab()} className="form-control" placeholder="Ingresa la C.I., nombre o apellido del estudiante" title="Ingresa una Cédula o Nombre y presiona la tecla ENTER"/>
                                    </Col>
                                    <Col md={6} align="right">
                                        {totalSeccion()}
                                    </Col>
                                </Row>
                            </div>
                            <div className="custom-mt-10">
                                {detallesEst()}
                            </div>
                            {detReg()}
                        </React.Fragment>
                    )
                default:
                    return(
                        <div className="text-danger" align="center">Selecciona el Tipo de Consulta</div>
                    )
            }
        }

        const Opciones = [
            { value: 'dia', label: 'Ingresos del Dia' },
            { value: 'mes', label: 'Ingresos del Mes' },
            { value: 'rango', label: 'Ingresos por Rango de Fechas' },
            { value: 'seccion', label: 'Ingresos por Sección' },
            { value: 'estudiante', label: 'Ingresos por Estudiante' },
        ];

        return (
            <React.Fragment>
                <div className="custom-alert-info">
                    <Row>
                        <Col md={7} style={{marginTop: 10, paddingLeft: 20}}>
                            Tipo de Consulta
                        </Col>
                        <Col md ={5}>
                            <Select
                                styles={customStyles}
                                isSearchable ={true}
                                value={tipoIngreso}
                                onChange={this.valorTipo}
                                options={Opciones}
                            />
                        </Col>
                    </Row>
                </div>
                <div className="custom-mt-10">{contentType()}</div>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En esta sección puedes observar el listado de ingresos. Seleccionando primero el <strong>Tipo de Consulta</strong>
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                <strong className="text-primary">Ingresos del Día</strong>
            </Col>
            <Col md={12} align="justify">
                Permite consultar los ingresos diarios obtenidos. Podrás ver un listado de ingresos del día detallado por estudiante
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                <strong className="text-primary">Ingresos del Mes</strong>
            </Col>
            <Col md={12} align="justify">
                Permite consultar los ingresos mensuales. En esta opción debes elegir un mes (por defecto <strong>Enero</strong>) y aparecerá el listado detallado
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                <strong className="text-primary">Rango de Fechas</strong>
            </Col>
            <Col md={12} align="justify">
                Permite consultar los ingresos en un rango de fecha seleccionado. En esta ocación debes elegir la fecha de inicio (<strong>Desde</strong>) y la fecha (<strong>Hasta</strong>) para realizar la búqueda. Luego presiona el botón <button className="btn btn-primary btn-sm" style={{borderWidth: 1}}><i className="fa fa-search"></i> Buscar</button>
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                <strong className="text-primary">Ingresos por Sección</strong>
            </Col>
            <Col md={12} align="justify">
                Permite consultar los ingresos de la sección. Para esto debes seleccionar: <strong>La Carrera</strong>, <strong>El Semestre</strong> y <strong>La Sección</strong> para realizar la consulta.
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                <strong className="text-primary">Ingresos por Estudiante</strong>
            </Col>
            <Col md={12} align="justify">
                Permite consultar los ingresos un estudiante específico. Para efectuar esta consulta ingresa <strong>La Cédula</strong>, <strong>El Nombre</strong> o <strong>El Apellido</strong> y presiona la tecla <strong>ENTER</strong>
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                Luego de seleccionar el Tipo de Consulta puedes imprimir el listado presionando el botón <button className="btn btn-sm btn-relleno-danger"><i className="fa fa-print"></i> Imprimir</button>
            </Col>
        </Row>
    )

    modalReporte = () => {
        let { openWR, tipoIngreso, cantRegistros, ingresos, transacciones, mesSelect, fecha, fecha2,
            valorSeccion, string, histEst } = this.state;
        if (openWR === false ) return null;

        return (
            <ModalReports
                reporte={<IngresosRpt tipo = {tipoIngreso.label} cantidad = {cantRegistros.value} ingresos = {ingresos}
                        transacciones = {transacciones} mes = {mesSelect.value} fecha = {fecha} fecha2 = {fecha2}
                        seccion = {valorSeccion.label} busqueda = {string} hist = {histEst}/>}
                titulo={`Control de ${tipoIngreso.label}`}
                display= "block"
                cerrar = {() => {this.setState({openWR: false})}}
            />
        )
    }

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Control de Ingresos</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalReporte()}
            </div>
        );
    }
}
 
export default GeneralIngresos;


// WEBPACK FOOTER //
// ./src/views/Administracion/IngresosContent/GeneralIngresos.jsx